export { en, type TranslationKeys } from './translations/en';
export { lv } from './translations/lv';
export { ru } from './translations/ru';

export type Language = 'en' | 'lv' | 'ru';

export const languages: { code: Language; name: string; nativeName: string }[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'lv', name: 'Latvian', nativeName: 'Latviešu' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
];

export const defaultLanguage: Language = 'lv';
